/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_Prep_Generate_FailedInputs */



/**
* | output |
* | --- |
* | "That did not work. Try again, or write your own topics." |
*
* @param {Meeting_Prep_Generate_FailedInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meeting_prep_generate_failed = /** @type {((inputs?: Meeting_Prep_Generate_FailedInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Prep_Generate_FailedInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Dat lukte niet. Probeer het opnieuw of schrijf je punten zelf.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Cela n'a pas fonctionné. Réessayez ou écrivez vos sujets vous-même.")
	return /** @type {LocalizedString} */ ("That did not work. Try again, or write your own topics.")
});